import SearchComponent from '@components/inputs/search/Search.component';
import ModalComponent from '@components/modal/Modal.component';
import { Colors } from '@constants/colors.constants';
import { Box, Button, Divider, Stack, Typography } from '@mui/material';
import {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import {useObservable} from '@ngneat/react-rxjs';
import {auditsQuery} from '@store/audits/audits.query';
import {auditsService} from '@store/audits/audits.service';
import {Audit} from '@store/audits/audits.model';
import {useSnackbar} from 'notistack';

interface MergeModalProps {
  handleClose: () => void;
  firstAudit: Audit;
}


const MergeModal = (props: MergeModalProps) => {
  const { t } = useTranslation();
  const { handleClose, firstAudit } = props;
  const [isSelected, setIsSelected] = useState<number>();
  const [ auditsMerges ] = useObservable(auditsQuery.auditsMerges$);
  const [ searchMerge, setSearchMerge ] = useState<string|undefined>('');
  const { enqueueSnackbar } = useSnackbar();

  const handleClick = (auditId: number) => {
    setIsSelected(isSelected !== auditId ? auditId : undefined);
  };

  const mergeAudits = () => {
        auditsService.mergeAudits({
            firstAuditId: firstAudit.id,
            secondAuditId: isSelected!
        }).pipe()
            .subscribe({
                next: () => {
                    enqueueSnackbar(t('audits.success.merge'), { variant: 'success' });
                    handleClose();
                },
                error: (err) => enqueueSnackbar(err.text, err.options),
            });
    };

    useEffect(() => {
        searchAudits();
        setSearchMerge('');
        // eslint-disable-next-line
    }, []);

  const searchAudits = (value?: string) => {
      setSearchMerge(value);
      auditsService.searchAudits(value).pipe()
          .subscribe({
              error: (err) => enqueueSnackbar(err.text, err.options),
          });
  };

  return (
    <ModalComponent
      handleClose={handleClose}
      title={t('audits.modals.merge.title')}
      content={(
        <Stack width="90%" pt="55px" pb="10px" overflow="auto">
         <Box width="100%" mb="24px">
            <SearchComponent
              value={searchMerge}
              handleChange={(value) => {
                searchAudits(value);
              }}
            />
          </Box>
          <Divider sx={{ border: 'solid 1px RGBA(134, 143, 156, 0.22)', }} />
          {auditsMerges.map((audit) => (
            <Stack key={audit.id} onClick={() => handleClick(audit.id)} pt="20px" sx={{
              '&:hover': { backgroundColor: '#DEE0E2' }
            }}>
              <Stack direction="row" justifyContent="space-between" px="5px" >
                <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                  <Box width="20px" height="20px" borderRadius="50px" bgcolor={isSelected === audit.id ? '#6FD969' : 'transparent'} sx={{ border: '2px solid #6FD969' }} />
                  <Typography fontWeight={400} fontSize="16px" color={Colors.black}>{audit.name}</Typography>
                </Stack>
                <Typography fontWeight={400} fontSize="14px" color={Colors.lightGrey}>{audit.participants}</Typography>
                <Typography fontWeight={400} fontSize="14px" color={Colors.lightGrey}>{t('global.dateAndHour', { date: new Date(audit.updatedAt) })}</Typography>
              </Stack>
              <Divider sx={{ border: 'solid 1px RGBA(134, 143, 156, 0.22)', marginTop: '20px' }} />
            </Stack>
          ))}
        </Stack>
      )}
      actions={(
        <Button
          variant="contained"
          color="primary"
          onClick={mergeAudits}>
          {t('global.merge')}
        </Button>
      )} />
  );
};

export default MergeModal;
